import axios from "axios";

const actualizarVenta = async TieneDespachos => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const idsMovimientosFac = JSON.parse(
    localStorage.getItem("idsMovimientosFac"),
  );
  const idPagoElectronico = localStorage.getItem("idPagoElectronico");
  const syncGUID = JSON.parse(localStorage.getItem("syncGUID"));

  const passEmpleados = JSON.parse(
    localStorage.getItem("passEmpleados") || "[]",
  );
  const primerEmpleado = passEmpleados[0];
  const idEmpleado = primerEmpleado ? primerEmpleado.idEmpleado : null;

  const userData = {
    nic: formattedNic,
    token: token,
    idsMovimientosFac: idsMovimientosFac,
    idEmpleadoResponsable: idEmpleado,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
    TieneDespachos: TieneDespachos,
    idPagoElectronico: idPagoElectronico,
    syncGUID: syncGUID,
  };
  console.log(JSON.stringify(userData));
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/api/Facturacion/ActualizarVentaQR`,
    {
      userData,
    },
  );
  return response.data;
};

const actualizarVentaQR = {
  actualizarVenta,
};

export default actualizarVentaQR;
